import { axiosInstance } from './api'

import { showErrorToast } from '../utils'
import { IBrand, IPaginateData } from '../interfaces'

export async function fetchBrands(
  authToken: string,
  page: number,
  search: string
): Promise<IPaginateData<IBrand> | undefined> {
  try {
    const response = await axiosInstance.get(
      `/brands?page=${page}&perpage=24&search=${search}`,
      {
        headers: {
          Authorization: `Bearer ${authToken}`
        }
      }
    )
    return response.data
  } catch (err) {
    showErrorToast('Algo deu errado, tente novamente!')
  }
}
